module.exports = require('./cityMap.json')


//////////////////
// WEBPACK FOOTER
// ./~/.0.0.1@cn-city/index.js
// module id = 408
// module chunks = 2